import React from "react";
import { FiShield, FiFileText, FiMail } from "react-icons/fi";
import { FaXTwitter, FaDiscord, FaYoutube } from "react-icons/fa6";

const iconUrl = new URL('../assets/katpack_icon_64.png', import.meta.url).href;

export function Footer({ config }) {
  const docsUrl = config?.docsUrl ?? "";
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-gray-900 border-t border-gray-700/60 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src={iconUrl} alt="KatPack" className="h-8 w-8 object-contain" />
              <span className="text-white font-bold text-base">KatPack.ai</span>
            </div>
            <p className="text-xs text-slate-400 leading-relaxed">
              Cooperative AI trading packs. Agents debate, vote, and reach consensus before any trade fires on Hyperliquid.
            </p>
            <p className="mt-4 text-xs text-slate-500">
              © {year}{" "}
              <a href="https://deeporblabs.com" className="hover:text-cyan-300" target="_blank" rel="noreferrer">
                DeepOrb Labs
              </a>
              . All rights reserved.
            </p>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href={`${docsUrl}/notices/privacy/`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-purple-300 transition-colors"
                >
                  <span className="text-purple-400/70"><FiShield className="h-4 w-4" /></span>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href={`${docsUrl}/notices/tos/`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-purple-300 transition-colors"
                >
                  <span className="text-purple-400/70"><FiFileText className="h-4 w-4" /></span>
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="mailto:kitty@katbot.xyz"
                  className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                >
                  <FiMail className="h-4 w-4 text-cyan-400/70" />
                  kitty@katbot.xyz
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide mb-4">Community</h3>
            <div className="flex flex-col gap-2">
              <a
                href="https://x.com/kitty_katbot"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-lg border border-cyan-500/25 bg-cyan-500/10 px-3 py-1.5 text-xs text-cyan-300 hover:bg-cyan-500/20 transition-colors w-fit"
              >
                <FaXTwitter className="h-3.5 w-3.5" />
                @kitty_katbot
              </a>
              <a
                href="https://discord.gg/asTcxUTzRv"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-lg border border-purple-500/25 bg-purple-500/10 px-3 py-1.5 text-xs text-purple-300 hover:bg-purple-500/20 transition-colors w-fit"
              >
                <FaDiscord className="h-3.5 w-3.5" />
                Discord
              </a>
              <a
                href="https://www.youtube.com/@PurrfectIntel"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-lg border border-red-500/25 bg-red-500/10 px-3 py-1.5 text-xs text-red-300 hover:bg-red-500/20 transition-colors w-fit"
              >
                <FaYoutube className="h-3.5 w-3.5" />
                YouTube
              </a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}
